import { ActionBase } from '../../../core/store/action/ActionBase';

export const UNGROUP_RULE_CONDITIONS_SUCCESS = '[DynamicDataSet] Ungroup Rule Conditions Success';

export class UngroupRuleConditionsSuccessAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = UNGROUP_RULE_CONDITIONS_SUCCESS;

  constructor(public payload: { dynamicDataSetKey: string, dynamicRuleKey: string, groupName: string }) {}
}



// WEBPACK FOOTER //
// ./src/app/dynamicDataSets/store/actions/UngroupRuleConditionsSuccessAction.ts